import React from "react";
import CustomTable from "../General/customTable/CustomTable";
import moment from "moment";
import CustomLink from "../General/link/customLink";
import CustomModal from "../General/customModal";
import SolicitorGroupAddUnderwriterForm from "./solicitorGroupAddUnderwriterForm";
import {connect} from "react-redux";
import SolicitorGroupRemoveUnderwriterConfirmation from "./solicitorGroupRemoveUnderwriterConfirmation";

const UNDERWRITER_NOT_FOUND_MESSAGE =
    'The selected underwriter is not available for this solicitor group. Please select another one.';

const initialUW = [
    {
        underwriterName: 'dawn',
        validFrom: moment().subtract(15, 'days').toDate(),
        validTo: moment().subtract(10, 'days').toDate(),
    },
    {
        underwriterName: 'StPatrick',
        validFrom: moment().subtract(10, 'days').toDate(),
        validTo: moment().subtract(5, 'days').toDate(),
    },
    {
        underwriterName: 'AnFields',
        validFrom: moment().subtract(5, 'days').toDate(),
        validTo: null,
    },
];

class SolicitorGroupTechnicalUnderwriters extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: null,
            isCreateModalOpen: false,
            editingUW: null,
            deletingUWAtRowIndex: null,
            // set when the submitted underwriter cannot be found in the list this component was given;
            // cleared whenever a modal opens or closes so it can never outlive the attempt that set it
            lookupErrorMessage: null,
        }
    }

    openCreateModal = () => this.setState({isCreateModalOpen: true, lookupErrorMessage: null})

    closeCreateModal = () => this.setState({isCreateModalOpen: false, lookupErrorMessage: null})

    openEditModal = (uw) => {
        this.setState({
            editingUW: uw,
            lookupErrorMessage: null,
        })
    }

    closeEditModal = () => this.setState({editingUW: null, lookupErrorMessage: null})

    openDeleteModal = (rowIndex) => {
        if(moment(this.props.previousFromLastItemValidFromDate, 'DD/MM/YYYY').isAfter(moment())){
            return this.onDeleteUnderwriter(rowIndex, false);
        }

        this.setState({
            deletingUWAtRowIndex: rowIndex,
        })
    }

    closeDeleteModal = (uw) => {
        this.setState({
            deletingUWAtRowIndex: null,
        })
    }

    onUnderwriterCreate = (underwriter) => {
        const matchedUW = this.props.underwriters.find(u => (
            u.id
            && underwriter.underwriter
            && u.id.toString() === underwriter.underwriter.toString()
        ));

        // without a message the modal would just sit there doing nothing on every submit, with no
        // indication that the underwriter behind the selected id is not one this form knows about
        if(!matchedUW){
            return this.setState({lookupErrorMessage: UNDERWRITER_NOT_FOUND_MESSAGE});
        }

        this.props.addUnderwriter({
            underwriter: {
                updateRelatedPolicies: underwriter.updateRelatedPolicies,
                underwriterId: matchedUW.id,
                underwriterName: matchedUW.name,
                validFrom: moment(underwriter.validFrom, 'DD/MM/YYYY').toDate(),
                validTo: null,
            }
        })

        this.closeCreateModal();
    }

    onEditUnderwriter = (underwriter) => {
        const matchedUW = this.props.underwriters.find(u => (
            u.id
            && underwriter.underwriter
            && u.id.toString() === underwriter.underwriter.toString()
        ));

        // see onUnderwriterCreate - the same silent dead end, reachable here from a row whose
        // underwriter is missing from the list rather than from a selection the user just made
        if(!matchedUW){
            return this.setState({lookupErrorMessage: UNDERWRITER_NOT_FOUND_MESSAGE});
        }

        this.props.editUnderwriter({
            underwriter: {
                updateRelatedPolicies: underwriter.updateRelatedPolicies,
                underwriterId: matchedUW.id,
                underwriterName: matchedUW.name,
                validFrom: moment(underwriter.validFrom, 'DD/MM/YYYY').toDate(),
                validTo: null,

            }
        })

        this.closeEditModal();
    }

    onDeleteUnderwriter = (rowIndex, updateRelatedPolicies) => {
        this.props.removeUnderwriter(rowIndex, updateRelatedPolicies);

        this.closeDeleteModal();
    }

    render() {
        const {underwriters, removeUnderwriter, maxDateForUnderwriterCreateForm} = this.props;

        return (
            <div className={'form-group'}>
                <CustomModal
                    modelDepth={3}
                    isOpen={this.state.isCreateModalOpen}
                    content={(
                        <SolicitorGroupAddUnderwriterForm
                            underwriters={underwriters}
                            submitUnderwriter={this.onUnderwriterCreate}
                            submitErrorMessage={this.state.lookupErrorMessage}
                            minDate={this.props.newestValidFromDate}
                            maxDate={maxDateForUnderwriterCreateForm}
                        />
                        )}
                    handleClose={this.closeCreateModal}
                />
                <CustomModal
                    modelDepth={3}
                    isOpen={this.state.editingUW}
                    content={(
                        <SolicitorGroupAddUnderwriterForm
                            underwriters={underwriters}
                            submitUnderwriter={this.onEditUnderwriter}
                            submitErrorMessage={this.state.lookupErrorMessage}
                            initialUW={this.state.editingUW}
                        />
                        )}
                    handleClose={this.closeEditModal}
                />
                <CustomModal
                    modelDepth={3}
                    isOpen={this.state.deletingUWAtRowIndex}
                    content={(
                        <SolicitorGroupRemoveUnderwriterConfirmation
                            removeUnderwriter={this.onDeleteUnderwriter}
                            deletingUWAtRowIndex={this.state.deletingUWAtRowIndex}
                            previousFromLastItemValidFromDate={this.props.previousFromLastItemValidFromDate}
                        />
                        )}
                    handleClose={this.closeDeleteModal}
                />
                <div className={'col-sm-3'}>
                    <label className={"control-label.text-left formGroupSelectInput-label inputRequired"}>
                        {'Capacity Underwriter'}
                    </label>
                </div>
                <div className={'col-sm-9'}>
                    <CustomTable
                        responsive
                        striped
                        columns={[
                            {propertyName: "underwriterName", header: "Underwriter"},
                            {
                                propertyName: "validFrom",
                                header: "Valid from",
                                formatter: (row) => (
                                    row.validFrom
                                        ? moment(row.validFrom).format('DD/MM/YYYY')
                                        : ''
                                )
                            },
                            {
                                propertyName: "validTo",
                                header: "Valid to",
                                formatter: (row) => (
                                    row.validTo
                                        ? moment(row.validTo).format('DD/MM/YYYY')
                                        : ''
                                )
                            },
                        ]}
                        data={this.props.solicitorGroupUnderwriters}
                        hasActions
                        actions={[
                            {
                                key: 'Edit',
                                label: 'Edit',
                                callback: (row) => this.openEditModal(row),
                                customComponent: ({rowIndex, datum, action, key}) => (
                                    <div key={rowIndex} >
                                        {((rowIndex + 1) === this.props.solicitorGroupUnderwriters.length) && (
                                            <CustomLink
                                                label={action.label}
                                                onClick={() => action.callback(datum, rowIndex)}
                                            />
                                        )}
                                    </div>
                                )
                            },
                            {
                                key: 'Remove',
                                label: 'Remove',
                                callback: (row, datum) => this.openDeleteModal(row),
                                customComponent: ({rowIndex, datum, action, key}) => (
                                    <div key={rowIndex} >
                                        {(
                                            (rowIndex + 1) === this.props.solicitorGroupUnderwriters.length
                                            && this.props.solicitorGroupUnderwriters.length > 1
                                        ) && (
                                            <CustomLink
                                                label={action.label}
                                                onClick={() => action.callback(rowIndex)}
                                            />
                                        )}
                                    </div>
                                )
                            },
                        ]}
                    />
                </div>

                <div className={'col-sm-9 col-sm-offset-3'}>
                    <CustomLink
                        label={'Add Underwriter'}
                        onClick={this.openCreateModal}
                    />
                </div>

            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    const newestValidFromDate = (props.solicitorGroupUnderwriters && props.solicitorGroupUnderwriters.length > 0)
        ? moment(props.solicitorGroupUnderwriters[props.solicitorGroupUnderwriters.length - 1].validFrom)
            .add(1, 'days')
            .format('DD/MM/YYYY')
        : null;

    const previousFromLastItemValidFromDate = (props.solicitorGroupUnderwriters && props.solicitorGroupUnderwriters.length > 1)
        ? moment(props.solicitorGroupUnderwriters[props.solicitorGroupUnderwriters.length - 2].validFrom)
            .format('DD/MM/YYYY')
        : null;

    const maxDateForUnderwriterCreateForm =  (props.solicitorGroupUnderwriters && props.solicitorGroupUnderwriters.length === 0)
        ? moment().format('DD/MM/YYYY')
        : null;

    return {
        newestValidFromDate,
        previousFromLastItemValidFromDate,
        maxDateForUnderwriterCreateForm,
    }
}

export default connect(mapStateToProps, null)(SolicitorGroupTechnicalUnderwriters);